import { useState, useEffect } from 'react';

const useImpressionObserver = (selectorOrRef, onObservation) => {
    const [isComponentSeen, setIsComponentSeen] = useState(false);

    useEffect(() => {
        if (
            !window ||
            !window.IntersectionObserver ||
            typeof window.IntersectionObserver !== 'function'
        ) {
            return;
        }

        const element =
            typeof selectorOrRef === 'string'
                ? document.querySelector(selectorOrRef)
                : selectorOrRef?.current;

        if (!element) {
            return;
        }

        const intersectionObserver = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && !isComponentSeen) {
                setIsComponentSeen(true);

                onObservation();

                stopObservation();
            }
        });

        intersectionObserver.observe(element);

        const stopObservation = () => {
            intersectionObserver.disconnect();
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useImpressionObserver;
